<script setup lang="ts">
import { useForm } from "@inertiajs/vue3"
import AuthShell from "./components/AuthShell.vue"

const props = defineProps<{
  invitation_token: string
  invitation_email?: string
  invitation_company?: string
  errors?: Record<string, string[]>
}>()

const form = useForm({
  name: "",
  email: props.invitation_email ?? "",
  password: "",
  password_confirmation: "",
  invitation_token: props.invitation_token,
})

const fieldError = (field: string) => props.errors?.[field]?.[0]
</script>

<template>
  <AuthShell title="Aceitar convite" :subtitle="`Voce foi convidado para ${props.invitation_company ?? 'uma empresa'}.`">
    <form class="space-y-4" @submit.prevent="form.post('/users')">
      <input v-model="form.invitation_token" type="hidden" />

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="name">Nome</label>
        <input id="name" v-model="form.name" type="text" required class="w-full rounded border border-slate-300 px-3 py-2" />
        <p v-if="fieldError('name')" class="mt-1 text-sm text-rose-600">{{ fieldError('name') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="email">E-mail</label>
        <input id="email" v-model="form.email" type="email" required readonly class="w-full rounded border border-slate-300 bg-slate-100 px-3 py-2" />
        <p v-if="fieldError('email')" class="mt-1 text-sm text-rose-600">{{ fieldError('email') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="password">Senha</label>
        <input id="password" v-model="form.password" type="password" required class="w-full rounded border border-slate-300 px-3 py-2" />
        <p v-if="fieldError('password')" class="mt-1 text-sm text-rose-600">{{ fieldError('password') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="password_confirmation">Confirmar senha</label>
        <input id="password_confirmation" v-model="form.password_confirmation" type="password" required class="w-full rounded border border-slate-300 px-3 py-2" />
      </div>

      <button type="submit" :disabled="form.processing" class="w-full rounded bg-indigo-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60">
        Ativar acesso
      </button>
    </form>
  </AuthShell>
</template>
